module.exports = __webpack_public_path__ + "5ee9d6fcc1e564d78d510c869447133c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-4.png
// module id = 2111
// module chunks = 0